import "../../../../lib/store/createAppApi.js";
import "../../../../lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../lib/store/createAppSelector.js";
import "../../../../lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../lib/store/hooks/useAppDispatch.js";
import "../../../../lib/store/hooks/useAppSelector.js";
import "../../../../lib/store/hooks/useAppStore.js";
import { flattenFilterGridItems } from "../../lib/flattenFilterGridItems.js";
import { selectFilterGrid } from "./selectFilterGrid.js";
const selectFilterGridItems = createAppSelector(selectFilterGrid, (filterGrid) => {
  if (!filterGrid) {
    return [];
  }
  return flattenFilterGridItems(filterGrid);
});
export {
  selectFilterGridItems
};
